/* eslint-disable max-len */
import request from '../../../api';
import {
  QueryOnboardingOptionsRes, QueryOnboardingOptionsReq, OnboardingFormReq, OnboardingFormRes,
} from './types';

type ReturnType<T> = [boolean, T | null];

const queryOnboardingOptions: (params: QueryOnboardingOptionsReq) => Promise<ReturnType<QueryOnboardingOptionsRes>> = async (params) => {
  let hasError = false;
  try {
    const res = await request('query-onboarding-options', {
      method: 'POST',
      body: params,
    });
    return [hasError, res];
  } catch (err) {
    console.error('err', err);
    hasError = true;
    return [hasError, null];
  }
};

const openOnboarding: (params: OnboardingFormReq) => Promise<ReturnType<OnboardingFormRes>> = async (params) => {
  let hasError = false;
  try {
    const res = await request('open-platform-onboarding', {
      method: 'POST',
      body: params,
    });
    return [hasError, res];
  } catch (err) {
    console.error('err', err);
    hasError = true;
    return [hasError, null];
  }
};

export { queryOnboardingOptions, openOnboarding };
